export default __webpack_public_path__ + "static/media/hero.52a68e93.png";